
import React from 'react'
import KrpanoTours from './components/KrpanoTours/KrpanoTours'
import TourSettings from './components/TourSettings/TourSettings'
import InfoDialog from './components/InfoDialog/InfoDialog'
import PositionName from './components/PositionName/PositionName'
import ToursMap from './components/LeafletMap/ToursMap'
import './App.css';

import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import SettingsIcon from '@material-ui/icons/Settings';
import { connect } from "react-redux";

import Grid from '@mui/material/Grid';

import * as dotenv from 'dotenv';
dotenv.config();

class App extends React.Component{

  constructor(props){
    super(props);
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.state = {openedDrawer : false};
  }

  toggleDrawer() {
    this.setState(state => ({
      openedDrawer: !state.openedDrawer
    }));
  }


  getToursFromServer() {

    var obj1 = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Origin': 'https://www.360bilder.no',
      },
    }

    var folder = '';

    console.log(window.URL);

    fetch("https://www.360bilder.no/fv564/settings.php",obj1)
        .then(response => response.json())
        .then(data => {
           folder = data.data.features[0].properties.pos;

          var obj = {  
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Origin': 'https://www.360bilder.no',
            },
          }
          
          fetch("https://www.360bilder.no/fv564/menu.php?folder=" + folder,obj)
              .then(response => response.json())
              .then(data => {
                  this.props.setTourName(folder);
                  this.props.setTours(data.data);
                  if(data.data.length != 1){
                    this.props.setUpper(folder + "/" + data.data[0]);
                    this.props.setBelow(folder + "/" + data.data[1]);
                  }else{
                    this.props.setUpper(folder + "/" + data.data[0]);
                    this.props.setBelow(undefined);
                  }
                  
              }).catch(err=>{
                console.log(err)
              }).finally(() => {
                  
                }
              );
        }).catch(err=>{
          console.log(err)
        }).finally(() => {
            
          }
        );
  }

  

  componentDidMount() {
    this.getToursFromServer();
  }

  getSizeForUpperWindow(){
    const result = this.props.mapSliderValue/10;
    return result;
  }

  getSizeForLowerWindow(){
    const result = (120-this.props.mapSliderValue)/10;
    return result;
  }


  render (){
    return (
          <div id="app">
          <IconButton variant="contained" onClick={this.toggleDrawer} id="settings_button">
            <SettingsIcon style={{ color: 'white' }}></SettingsIcon>
          </IconButton>
          {/* <PositionName/> */}
          <Drawer anchor={'left'} open={this.state.openedDrawer} onClose={this.toggleDrawer}>
              <TourSettings closeDrawer={this.toggleDrawer}/>
          </Drawer>
          
            <Grid container direction="row" spacing={0} wrap="nowrap">
              <InfoDialog/>

              <Grid item xs={this.props.map ? this.getSizeForUpperWindow() : 12}  zeroMinWidth>
                <KrpanoTours noWrap/>
              </Grid>
              <Grid item xs={this.props.map ? this.getSizeForLowerWindow() : 0}>
                <ToursMap/>
              </Grid>
            </Grid>
          
          </div>
    )
  }
}



const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => ({
  setUpper: (tourWin) => dispatch({type: "update/upperWindow", tour: tourWin}), 
  setBelow: (tourWin) => dispatch({type: "update/belowWindow", tour: tourWin}),
  setTours: (tours)   => dispatch({type: "update/tours",       tours: tours}),
  setTourName: (tourName)=> dispatch({type: "update/tourName",       tourName: tourName}),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
